// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.js';
import { ModalProvider, useModal } from './context/ModalContext.js';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Layout from './components/Layout.jsx';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import ProductsPage from './pages/ProductsPage.jsx';
import ProductFormPage from './pages/ProductFormPage.jsx';
import AdminsPage from './pages/AdminsPage.jsx';
import OrdersPage from './pages/OrdersPage.jsx';
import Modal from './components/Modal.jsx';
import './App.css';

function App() {
    return (
        <AuthProvider>
            <ModalProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        
                        <Route path="/" element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }>
                            <Route index element={<Navigate to="/dashboard" replace />} />
                            
                            <Route path="dashboard" element={<DashboardPage />} />
                            
                            <Route path="products" element={
                                <ProtectedRoute requiredPermission="canViewProducts">
                                    <ProductsPage />
                                </ProtectedRoute>
                            } />
                            
                            <Route path="products/create" element={
                                <ProtectedRoute requiredPermission="canManageProducts">
                                    <ProductFormPage />
                                </ProtectedRoute>
                            } />
                            
                            <Route path="products/edit/:id" element={
                                <ProtectedRoute requiredPermission="canEditProducts">
                                    <ProductFormPage />
                                </ProtectedRoute>
                            } />

                            <Route path="orders" element={
                                <ProtectedRoute requiredPermission="canViewOrders">
                                    <OrdersPage />
                                </ProtectedRoute>
                            } />
                            
                            <Route path="admins" element={
                                <ProtectedRoute requiredPermission="canManageAdmins">
                                    <AdminsPage />
                                </ProtectedRoute>
                            } />
                        </Route>
                    </Routes>
                </BrowserRouter>
                
                {/* Глобальное модальное окно */}
                <ModalContainer />
            </ModalProvider>
        </AuthProvider>
    );
}

// Компонент-контейнер для модального окна
const ModalContainer = () => {
    const { modalState, hideModal, handleConfirm } = useModal();
    
    return (
        <Modal
            isOpen={modalState.isOpen}
            onClose={hideModal}
            onConfirm={handleConfirm}
            type={modalState.type}
            title={modalState.title}
            message={modalState.message}
            confirmText={modalState.confirmText}
            cancelText={modalState.cancelText}
        />
    );
};

export default App;